import { Button, Checkbox, FlyoutButton } from '@acpaas-ui/react-components';
import { ORDER_CHANGE_DIRECTION } from '../../constants/table.constants';

const TableTopBar = ({
  title,
  legend,
  actions,
  fields,
  isLoading,
  onFieldEnableChange,
  onFieldOrderChange,
  required
}) => {
  return (
    <div className="m-table-filter">
      <div className="m-table-filter__top-bar">
        {legend ? legend : null}
        {title && <h6 className={required && 'm-table-filter__title--required'}>{title}</h6>}
        <div className="m-table-filter__actions">
          {actions}
          <FlyoutButton
            disabled={isLoading}
            flyoutDirection="right"
            flyoutSize="medium"
            size="small"
            icon="ai-layout-column"
            outline
            flyoutHasPadding
            title="Kolominstellingen openen"
            ariaLabel="Kolominstellingen openen"
          >
            {fields?.map((field, index) => (
              <div key={field.value} className="m-table-column-selector">
                <Checkbox
                  label={field.label}
                  checked={!!field.show}
                  disabled={isLoading}
                  onChange={() => onFieldEnableChange(field.value, !field.show)}
                />
                <div className="m-table-column-selector__order">
                  <Button
                    onClick={() => onFieldOrderChange(field.value, ORDER_CHANGE_DIRECTION.UP)}
                    icon="ai-arrow-up-1"
                    disabled={isLoading || index === 0}
                    ariaLabel={`Bestel kolom ${field.label} omhoog`}
                    title={`Bestel kolom ${field.label} omhoog`}
                    size="small"
                    negative
                  ></Button>
                  <Button
                    onClick={() => onFieldOrderChange(field.value, ORDER_CHANGE_DIRECTION.DOWN)}
                    icon="ai-arrow-down-1"
                    disabled={isLoading || index + 1 === fields.length}
                    ariaLabel={`Bestel kolom ${field.label} omlaag`}
                    title={`Bestel kolom ${field.label} omlaag`}
                    size="small"
                    negative
                  ></Button>
                </div>
              </div>
            ))}
          </FlyoutButton>
        </div>
      </div>
    </div>
  );
};

export default TableTopBar;
